<template>
    <div id="programa-obra-estimaciones">
      <!-- Mensaje Estimacion no tiene programa -->
      <v-alert
        v-if="estimacion.programa.length <=0"
        type="info"
        :icon="false"
        class="mt-3">
          <v-card color="info"
          v-if="estimacion.programa.length <=0"
          flat>
            <v-card-title>Programa de Obra</v-card-title>
              <v-card-text>
                <span v-if="!contrato.esObraFinanciada">
                No existe <b>programa de obra</b> para esta estimación
                </span>
              </v-card-text>
          </v-card>
      </v-alert>

      <!-- Card para listar el programa de obra de la estimacion -->
      <v-card flat
      v-if="estimacion.programa.length >0">
        <v-toolbar flat>
          <v-toolbar-title
            class="secondary--text">
            Programa de obra
          </v-toolbar-title>
          <v-tooltip
            top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="estimacion.programa.length >0"
                icon
                class="ml-2"
                v-bind="attrs"
                v-on="on"
                @click="preEliminarPrograma(estimacion.id)">
                <v-icon>
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
            <span>
              Eliminar programa
            </span>
          </v-tooltip>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-list>
          <template
            v-for="(
              {
                id,
                fechaInicio,
                fechaTermino,
                plazo,
                monto,
              },
              index
            ) in listado"
          >
            <v-list-item :key="id" link>
              <v-list-item-action>
                <v-chip>
                  {{ index + 1 }}
                </v-chip>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="font-weight-bold">
                    {{ new Date(`${fechaInicio} 00:00:0`).toLocaleDateString() }}
                    -
                    {{ new Date(`${fechaTermino} 00:00:0`).toLocaleDateString() }}
                  </span>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <span>Plazo</span>
                  {{ plazo }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-row
                  align="center"
                  justify="space-between">
                  <v-col
                    cols="auto">
                  </v-col>
                  <v-col
                    cols="auto">
                    <span class="success--text font-weight-medium">
                      {{ monto | currency }}
                    </span>
                  </v-col>
                </v-row>
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="index + 1 !== listado.length" :key="`divider-${id}`">
            </v-divider>
          </template>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div class="secondary--text font-weight-medium title">
          <span>
            {{ sumaPrograma(estimacion.programa) | currency }}
          </span>
        </div>
      </v-card-actions>
      </v-card>

  <!-- Pregunta de confirmacion para eliminar programa -->
  <v-dialog
      v-if="idPrograma"
      v-model="mostrarEliminarPrograma"
      width="450"
      persistent>
      <v-card>
      <v-card-title>
        Eliminar Programa
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        ¿Desea eliminar el  <b>Programa de Obra</b> de la Estimación {{this.estimacion.numero}}?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrarVentana"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3">
        </custom-button>
        <custom-button
          @click="mixEliminarProgramaEstimacion"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar">
        </custom-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>
<script>

import REMOVER_CONTRATO_ESTIMACION_PROGRAMA from '@/graphql/mutations/administracion/ejecuccion/estimaciones/removerContratoEstimacionPrograma.gql';
import CONTRATO_ESTIMACIONES from '@/graphql/querys/administracion/ejecucion/estimaciones/contratoEstimaciones.gql';
import CustomButton from '@/components/buttons/Button.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ProgramaObraEstimaciones',
  props: {
    estimacion: {
      type: Object,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      idPrograma: '',
      mostrarEliminarPrograma: false,
      enviandoFormulario: false,
    };
  },
  computed: {
    listado() {
      if (!this.estimacion.programa) return [];
      return this.estimacion.programa
        .slice()
        .sort(
          (a, b) => new Date(`${a.fechaTermino} 00:00:0`)
            - new Date(`${b.fechaTermino} 00:00:0`),
        );
    },

  },
  methods: {
    sumaPrograma(programa) {
      return this.$ObjSumar(programa, 'monto');
    },
    preEliminarPrograma(id) {
      this.mostrarEliminarPrograma = true;
      this.idPrograma = id;
    },
    cerrarVentana() {
      this.mostrarEliminarPrograma = false;
    },
    async mixEliminarProgramaEstimacion() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      // Eliminar programa de la estimacion
      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_ESTIMACION_PROGRAMA,
        variables: {
          idEstimacion: this.estimacion.id,
        },
        update: (store) => {
          // Query
          const query = {
            query: CONTRATO_ESTIMACIONES,
            variables: {
              idContrato: this.contrato.id,
            },
          };
          const data = store.readQuery(query);
          // Encontrar el estimacion
          const index = data.contratoEstimaciones
            .findIndex(({ id }) => id === this.estimacion.id);
          // Quitar programa de obra de la estimacion encontrada
          const estimacionEncontrada = data.contratoEstimaciones
            .find(({ id }) => id === this.estimacion.id);
          estimacionEncontrada.programa = [];
          // Si el index existe
          if (index !== -1) {
            // Remover la estimacion
            data.contratoEstimaciones.splice(index, 1);
          }
          // Agrega la estimacion sin programa
          data.contratoEstimaciones.push(estimacionEncontrada);
          // Actualizar la store
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrarVentana();
      eventBus.$emit('cerrar-ventana-programa-obra-estimaciones');
    },
  },
};
</script>
